export const CAN_EDIT_UNI_SETTINGS = 1 << 0;
export const CAN_EDIT_UNI_CONTENT = 1 << 1;
export const CAN_SEND_UNI_SMS = 1 << 2;
export const CAN_ACCESS_UNI_NEWS_AND_EVENTS = 1 << 3;
export const CAN_ACCESS_UNI_CHAT = 1 << 4;

/** time after which stats are no longer considered fresh */
export const OUTDATED_INTERVAL_STATS = 30 * 60 * 1000;
